import {
  LoadingContainer,
  LegacyPage,
  Model,
  Panels,
  Bar,
} from 'peach/components'
import { useParams } from 'peach/router'

import { useGetNotificationTypesInternal } from 'core/types'

const LoanTypeNotifications = () => {
  const { companyId, loanTypeId } = useParams<{
    companyId?: string
    loanTypeId?: string
  }>()

  const { data: notifications, isLoading } = useGetNotificationTypesInternal({
    companyId,
    loanTypeId,
  })

  const header = <Bar title='Notifications' />

  return (
    <LoadingContainer isLoading={isLoading}>
      <Panels header={header}>
        <LegacyPage.Full>
          <Model.Item json={notifications} title='Notifications' />
        </LegacyPage.Full>
      </Panels>
    </LoadingContainer>
  )
}

export default LoanTypeNotifications
